
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/location-admin",
      function () {
        return require("private-next-pages/location-admin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/location-admin"])
      });
    }
  